/** The file was automatically generated. Please do not modify manually */
import pt_br from './online.json';
export var strings_pt_br = pt_br;
